<script lang="ts" setup>
	import type { ClassNameValue } from 'tailwind-merge'
	import type { RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric } from 'vue-router'

	const {
		action = 'button',
		type = 'button',
		variants = 'one',
		...prop
	} = defineProps<{
		type?: HTMLButtonElement['type']
		text?: string
		loading?: boolean
		action?: 'button' | 'link'
		variants?: 'one' | 'two'
		to?: string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric | undefined
		/**
		 * @description This only works when the action attribute is set to 'link'
		 * */
		target?: '_blank' | '_self' | '_parent' | '_top' | undefined
		external?: boolean
	}>()
	defineOptions({
		inheritAttrs: false
	})

	const attr = useAttrs()
	const attrClass = computed(() => String(attr.class) as ClassNameValue)
	const colorVariant = computed(() =>
		variants === 'one' ? 'bg-primary-2 text-white hover:bg-primary-2/80 ' : variants == 'two' ? 'bg-gray-200' : ''
	)
</script>

<template>
	<button
		v-if="action === 'button'"
		:type
		:disabled="loading"
		v-bind="attr"
		:class="
			cn(
				'custom-transition-2 inline-flex items-center justify-center rounded-lg px-[8px] py-[15px] text-center text-sm font-semibold active:scale-105 disabled:cursor-not-allowed disabled:opacity-60',
				colorVariant,
				attrClass
			)
		"
	>
		<slot v-if="loading" name="loading">
			<tools-icon
				class="pr-3"
				icon="eclipse"
				dir="line"
				circle-class="stroke-gray-200"
				:height="20"
				:width="20"
			/>
		</slot>
		<slot>
			{{ text }}
		</slot>
	</button>
	<nuxt-link
		v-else-if="action === 'link'"
		:to="to || '/'"
		v-bind="attr"
		:class="
			cn(
				'custom-transition-2 inline-flex items-center justify-center rounded-lg px-[8px] py-[15px] text-center text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-60',
				colorVariant,
				attrClass
			)
		"
		:target
		:external
	>
		<slot v-if="loading" name="loading">
			<tools-icon
				class="pr-3"
				icon="eclipse"
				dir="line"
				circle-class="stroke-gray-200"
				:height="20"
				:width="20"
			/>
		</slot>
		<slot>
			{{ text }}
		</slot>
	</nuxt-link>
</template>
